module.exports = __webpack_public_path__ + "assets/img/picture4.e2a65614.png";